export default __webpack_public_path__ + "static/media/01.b2b6d3ec.webp";